import React, { useState} from 'react';

const LineSectorFilterContainerViewing = ({ handleSectorCheckboxChange, showWifiCoverage, handleLinePointToPointWifiCheckboxChange, showLinePointToPointWifi,
      handleLineSwToPointWifiCheckboxChange, showLineSwToPointWifi, handleSwitchCheckboxChange, showSwitch, handleBaseStationCheckboxChange,
      showBaseStation, handleStationCheckboxChange, showStation, handleApCheckboxChange, showAp, handleHousesActivChange, showHousesActiv,
      handleHousesNoActivChange, showHousesNoActiv, handleSwRank3Change, showRank3, handleSwRank12Change, showRank12 }) => {

  const [isVisibleDiv, setIsVisibleDiv] = useState(false);

  function toggleVisibilityDiv() {
    setIsVisibleDiv(!isVisibleDiv);
  }
    
  return (
  <React.Fragment>
  <button onClick={toggleVisibilityDiv} className={isVisibleDiv ? 'buttonIsHideDrawer' : 'buttonIsHideDrawer2'}>
    {isVisibleDiv ? 'Фильтр: скрыть' : 'Фильтр: показать'}
  </button>

 {isVisibleDiv && ( 
    <div className='equipmentDiv' style={{marginTop: "10px",textShadow: '2px 2px 4px #242424'}}>
      <label className='typeLabelDiv' style={{textShadow: "1px 1px 2px #000000ff"}}>Зоны</label>
      <hr className='horizontalLineDrawer' style={{background: 'black'}}/>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showWifiCoverage}
          onChange={handleSectorCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>Покрытие</label>
      </div>
    <br/>
     <label className='typeLabelDiv' style={{textShadow: "1px 1px 2px #000000ff"}}>Линки</label>
      <hr className='horizontalLineDrawer' style={{background: 'black'}}/>
       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showLinePointToPointWifi}
          onChange={handleLinePointToPointWifiCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2', textShadow: "1px 1px 2px #000000ff"}}>WiFi - WiFi</label>
        
      </div>

       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showLineSwToPointWifi}
          onChange={handleLineSwToPointWifiCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>Switch - WiFi</label>
      </div>
        <br/>
       <label className='typeLabelDiv' style={{textShadow: "1px 1px 2px #000000ff"}}>Активка</label>
      <hr className='horizontalLineDrawer' style={{background: 'black'}}/>
       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showSwitch}
          onChange={handleSwitchCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>Switch uplink</label>
        
      </div>
       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showBaseStation}
          onChange={handleBaseStationCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>BaseStation</label>
        
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showStation}
          onChange={handleStationCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>Station</label>
      </div>
       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showAp}
          onChange={handleApCheckboxChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>AccessPoint</label>
        
      </div>
       <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showRank12}
          onChange={handleSwRank12Change}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>100К/30К</label>
        
      </div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showRank3}
          onChange={handleSwRank3Change}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>3K</label>
        
      </div>
       <br/>
       <label className='typeLabelDiv' style={{textShadow: "1px 1px 2px #000000ff"}}>Дом</label>
       
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showHousesActiv}
          onChange={handleHousesActivChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>С услугой</label>   
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <input
          type="checkbox"
          checked={showHousesNoActiv}
          onChange={handleHousesNoActivChange}
          style={{ marginRight: '5px' }}
        />
        <label style={{ marginRight: '10px' , color: '#e2e2e2',textShadow: "1px 1px 2px #000000ff"}}>Без услуги</label>   
      </div>
     
    </div>  
     )}
     </React.Fragment>
  );
}

export default LineSectorFilterContainerViewing;